<!--
  TODO - On rewrite expand this component so it can accept custom text or icon.
       - rename to ClickToCopy
-->

<template>
  <span
    class="copy-number"
    @click="copyToClipboard" />
</template>

<script>
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'CopyNumber',
  mixins: [
    ToasterMixin,
  ],
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
  },
  methods: {
    copyToClipboard() {
      this.$clipboard(this.value);
      this.showToaster('Copied to clipboard.', null, null, 'OK');
    },
  },
};
</script>

<style lang="scss" scoped>
.copy-number {
  cursor: pointer;
  margin-left: 3px;
  display: block;
  width: 16px;
  height: 10px;
  background-image: url('~@/assets/img/SB-Icons/copy.svg');
  background-repeat: no-repeat;
  background-position: center;

  &:hover {
    background-image: url('~@/assets/img/SB-Icons/copy-hover.svg');
  }

  &.big-copy {
    width: 20px;
    height: 12px;
  }
}
</style>
